// extracted by mini-css-extract-plugin
module.exports = {"disclaimer":"DisclaimerFooter_disclaimer__1a5jV"};